<!--|||||||||||| SIDE MENU ||||||||||||-->
<div id="mySidenav" class="sidenav">

  <div class="row">
    <div class="w-100 pt-3 pb-1 d-flex align-items-center justify-content-start"
      style="padding-left: 20px; padding-right: 20px;">
      <div class="logo-container">
        <div *ngIf="configService.sellerConfiguration?.SellerLogo; else storeIcon" class="w-100 h-100">
          <img [src]="configService.sellerConfiguration?.SellerLogo" onerror="this.src='/assets/images/ecomshop.png'"
            style="height: 100%; object-fit: contain;">
        </div>

        <ng-template #storeIcon>
          <div class="w-100 h-100">
            <img src="/assets/images/ecomshop.png" style=" height: 100%; object-fit: contain;">
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="w-100 pb-3 pt-1" style="flex: 1; overflow-y: auto;">

    <div class="w-100">

      <!-- ===== REUSABLE MENU ROW TEMPLATE ===== -->
      <ng-template #menuRow let-item="item" let-inDisabledSection="inDisabledSection">

        <!-- LINK ITEM -->
        <div *ngIf="item.menuType === 'link'"
             class="menuItemWrap ripple"
             [class.disabled-link]="inDisabledSection">
          <div (click)="!inDisabledSection && !item.disabled && gotoPage(item.path)" class="d-flex align-items-start" style="gap: 0.5rem;">
            <i class="bi m-0" [ngClass]="item.icon"></i>
            <div class="d-flex flex-column">
              <div class="p-0"><a>{{ item.label }}</a></div>
              <div class="hint">{{ item.description }}</div>
            </div>
          </div>
        </div>

        <!-- EXPANDABLE ITEM -->
        <div *ngIf="item.menuType === 'expandable'"
             [style.opacity]="inDisabledSection ? '0.5' : '1'">
          <div class="d-flex flex-column">

            <div class="menuItemWrap ripple">
              <div class="d-flex align-items-start" style="gap: 0.5rem;" (click)="toggleItem(item)">
                <i class="bi m-0" [ngClass]="item.icon"></i>
                <div class="d-flex flex-column">
                  <div class="p-0 d-flex align-items-center">
                    <a>{{ item.label }}</a>
                    <span class="material-icons-outlined ml-2 expand-arrow-icon">
                      {{ !item.expanded ? 'expand_more' : 'expand_less' }}
                    </span>
                  </div>
                  <div class="hint">{{ item.description }}</div>
                </div>
              </div>
            </div>

            <div *ngIf="item.expanded" class="sub-menu pl-3 mt-1">
              <ng-container *ngFor="let subItem of item.children; trackBy: trackById">
                <div *ngIf="!subItem.hidden" class="menuItemWrap ripple" [class.disabled-link]="inDisabledSection || subItem.disabled">
                  <div class="d-flex align-items-start" style="gap: 0.5rem;">
                    <i class="bi m-0" [ngClass]="subItem.icon"></i>
                    <div class="d-flex flex-column">
                      <div class="p-0">
                        <a (click)="!inDisabledSection && !subItem.disabled && gotoPage(subItem.path)"> {{ subItem.label }} </a>
                      </div>
                      <div class="hint">{{ subItem.description }}</div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

          </div>
        </div>

      </ng-template>
      <!-- ===== END REUSABLE TEMPLATE ===== -->

      <!-- ===== ENABLED ITEMS (Top Section) ===== -->
      <ng-container *ngFor="let item of enabledMenuItems; trackBy: trackById">
        <ng-container *ngTemplateOutlet="menuRow; context: { item: item, inDisabledSection: false }"></ng-container>
      </ng-container>

      <!-- ===== DIVIDER ===== -->
      <div *ngIf="disabledMenuItems.length > 0" class="w-100 px-3 py-2">
        <hr style="margin: 0; border-top: 1px solid #e0e0e0;">
      </div>

      <!-- ===== DISABLED ITEMS (Bottom Section) ===== -->
      <ng-container *ngFor="let item of disabledMenuItems; trackBy: trackById">
        <ng-container *ngTemplateOutlet="menuRow; context: { item: item, inDisabledSection: true }"></ng-container>
      </ng-container>

    </div>
  </div>

  <div class="footer d-flex align-items-center justify-content-between " style="padding: 8px 20px;position: relative;"
    (click)="showProfileOptions()">
    <div class="d-flex align-items-center ">
      <div class="profile-letter-icon p-1">{{profileName?.charAt(0).toUpperCase() || "--"}}</div>
      <div class="ml-2 profile-name">{{profileName}}</div>
    </div>

    <div>
      <span class="material-icons-outlined ml-2 expand-arrow-icon">
        chevron_right
      </span>
    </div>

    <div *ngIf="profileMenu" class="d-flex flex-column profile-popup mx-2"
      style="position: absolute; bottom: 12%; left: 0; width: 95%;">

      <button (click)="closeProfileOptions();$event.stopPropagation()" class="profile-menu-close"
        style="position: absolute; top: 5px; right: 5px;">
        ✕
      </button>

      <ng-container *ngFor="let item of profileMenuList">
        <div [ngClass]="{ 'disabled-link': isThirdParty }" class=" menuItemWrap">
          <div class="d-flex align-items-center " style="gap: 0.5rem;">
            <i class="bi m-0" [ngClass]="item.icon"></i>
            <div class="d-flex flex-column">
              <div class=" p-0">
                <a (click)="gotoPage(item.path)"> {{ item.label }}</a>
              </div>
              <div class=" hint">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </ng-container>

    </div>

  </div>

  <div id="myCloseContainer" (click)="closeSideNav()" class="close-container">
    <div class="d-flex justify-content-end p-1">
      <div class="close-container-btn d-flex justify-content-center align-content-center">
        <i class="material-icons d-flex">close</i>
      </div>
    </div>
  </div>
</div>